import { normalizeWordApostrophe } from './normalizeWordApostrophe.js';

const ELLIPSIS_TOKEN = '\u0000';

/**
 * Shared answer comparison for student typing (words training + exercises).
 * Forgives case, smart quotes, apostrophe lookalikes, ellipsis form,
 * spaces around punctuation, collapsed whitespace, and trailing .,!?;:
 * Does not drop mid-string commas/punctuation that are part of the answer.
 */
export function normalizeAnswer(s) {
    if (!s || typeof s !== 'string') return s || '';
    return normalizeWordApostrophe(s)
        .toLowerCase()
        .trim()
        // Smart / typographic double quotes → ASCII "
        .replace(/[\u201c\u201d\u201e\u201f]/g, '"')
        // Ellipsis character / three dots → protect, then restore
        .replace(/\u2026/g, '...')
        .replace(/\.{3}/g, ELLIPSIS_TOKEN)
        .replace(/\s+/g, ' ')
        // No space before sentence/list punctuation
        .replace(/\s+([,.;:!?])/g, '$1')
        // Ensure a single space between punctuation and a following word (not another mark)
        .replace(/([,.;:!?])([^\s,.;:!?])/g, '$1 $2')
        .replace(new RegExp(ELLIPSIS_TOKEN, 'g'), '...')
        .replace(/\s+/g, ' ')
        .trim()
        // Trailing sentence punctuation (run of marks at end only)
        .replace(/[.,!?;:]+$/, '')
        .trim();
}
